var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.534 12.945a6.56 6.56 0 0 0 3.798-1.212l4.028 3.99a.97.97 0 0 0 .697.277c.552 0 .943-.42.943-.96a.9.9 0 0 0-.272-.673l-4.002-3.972a6.4 6.4 0 0 0 1.342-3.923c0-3.56-2.94-6.472-6.534-6.472C2.948 0 0 2.904 0 6.472c0 3.56 2.94 6.473 6.534 6.473m0-1.397c-2.804 0-5.123-2.298-5.123-5.076s2.32-5.075 5.123-5.075 5.124 2.298 5.124 5.075-2.32 5.076-5.124 5.076"
  })));
};
export default SvgSearch;